import { BallType } from 'lib_ts/enums/machine.enums';
import { Controller } from 'lib_ts/enums/routing/controllers';
import { TrainedMsRoutes } from 'lib_ts/enums/routing/routes/trained-machine-states';
import { IServerResponse } from 'lib_ts/interfaces/common/i-server-response';
import {
  IDeleteManyTrainedMss,
  ITrainedMachineState,
} from 'lib_ts/interfaces/training/i-trained-machine-state';
import { BaseRESTService } from 'services/_base-rest.service';

export class TrainedMsService extends BaseRESTService {
  private static instance: TrainedMsService;

  static getInstance(): TrainedMsService {
    if (!TrainedMsService.instance) {
      TrainedMsService.instance = new TrainedMsService();
    }

    return TrainedMsService.instance;
  }

  private constructor() {
    super({
      controller: Controller.TrainedMachineStates,
    });
  }

  upsertOne(model: Partial<ITrainedMachineState>) {
    return this.post(
      {
        uri: TrainedMsRoutes.UpsertOne,
      },
      model
    )
      .then((result: IServerResponse) => {
        if (!result.success) {
          console.error(
            result.error ?? 'Failed to upsert trained machine state'
          );
          return undefined;
        }

        return result.data as ITrainedMachineState;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  // todo: cache this on the server until a TMS record is changed
  findMany(model: Partial<ITrainedMachineState>) {
    return this.post(
      {
        uri: TrainedMsRoutes.FindMany,
      },
      model
    )
      .then((result: IServerResponse) => {
        if (!result.success) {
          console.error(
            result.error ?? 'Failed to find many trained machine states'
          );
          return [];
        }

        return result.data as ITrainedMachineState[];
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  findManyByBsHash(model: {
    machineID: string;
    ball_type: BallType;
    bs_hashes: string[];
  }) {
    return this.post(
      {
        uri: TrainedMsRoutes.FindManyByBsHash,
      },
      model
    )
      .then((result: IServerResponse) => {
        if (!result.success) {
          console.error(
            result.error ??
              'Failed to find many trained machine states by bs_hash'
          );
          return [];
        }

        return result.data as ITrainedMachineState[];
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  // only marks as deleted
  deleteManyByBsHash(config: IDeleteManyTrainedMss) {
    return this.post(
      {
        uri: TrainedMsRoutes.DeleteManyByBsHash,
      },
      config
    )
      .then((result: IServerResponse) => {
        if (!result.success) {
          console.error(
            result.error ??
              'Failed to delete many trained machine states by bs_hash'
          );
          return false;
        }

        return true;
      })
      .catch((error) => {
        console.error(error);
        return false;
      });
  }

  adjustForContTraining(tmsID: string) {
    return this.get({
      uri: `${TrainedMsRoutes.AdjustForContTraining}/${tmsID}`,
    })
      .then((result: IServerResponse) => {
        if (!result.success) {
          console.error(
            result.error ?? 'Failed to adjust for continuous training'
          );
          return undefined;
        }

        return result.data as ITrainedMachineState;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }
}
